export default (subject: string, length: number) => {
  if (subject.length < length) {
    return subject;
  }
  return subject.slice(0, length) + '...';
};
